import React, { useState, useEffect } from 'react';
import axios from '../Axiosinstance';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@material-ui/core';
import { TextField,Box } from '@mui/material';
import * as XLSX from "xlsx";
// const styles = {
//   container: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     flexWrap: "wrap", // Ensures responsiveness
//     gap: "10px",
//     marginBottom: "15px",
//     width: "100%",
//   },
//   buttonContainer: {
//     display: "flex",
//     justifyContent: "flex-end",
//     flex: 1,
//   },
//   button: {
//     whiteSpace: "nowrap", // Prevents text from breaking
//     padding: "10px 15px",
//     fontSize: "14px",
//     minWidth: "140px", // Ensures button stays visible
//     textAlign: "center",
//   },
//   searchInput: {
//     width: "220px",
//     minWidth: "200px", // Prevents search input from shrinking too much
//     marginTop: "10px",
//   },
// };
function StudentTable() {
  const [students, setStudents] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");

  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(10);

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };

  useEffect(() => {
    axios.get('students/deferred')
      .then(response => {
        setStudents(response.data);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, []);
  const exportToExcel = (data, fileName) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  // Filter students based on search query
  const filteredStudents = students.filter(student => {
    return (
      student.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });


  return (
    <TableContainer component={Paper}><br/>
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
      {/* Search input */}
      <TextField
        label="Search by Name"
        variant="outlined"
        fullWidth
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)} // Update search query
            InputLabelProps={{ shrink: true }}
      />
      
      {/* Download Excel Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={() =>
          exportToExcel(
            students.map((student, index) => ({
              'S.NO': index + 1,
              'Name': student.name.toUpperCase(),
              'Email': student.email,
              'Phone': student.handPhone,
              'Gender': student.gender,
              'Date of Birth': student.dob,
              'Status': student.status,
            })),
            'Students_Data'
          )
        }
     
      >
        Download Excel
      </Button>
    </div>


      <Table>
        <TableHead>
          <TableRow>
            <TableCell  style={{ fontWeight: 'bold', fontSize:'16px' }}>S.No</TableCell>
            <TableCell  style={{ fontWeight: 'bold', fontSize:'16px' }}>Name</TableCell>
            <TableCell style={{ fontWeight: 'bold' , fontSize:'16px'}}>Email</TableCell>
            <TableCell style={{ fontWeight: 'bold' , fontSize:'16px'}}>Phone</TableCell>
            <TableCell style={{ fontWeight: 'bold' , fontSize:'16px'}}>Gender</TableCell>
            <TableCell style={{ fontWeight: 'bold' , fontSize:'16px'}}>Date of Birth</TableCell>
            {/* <TableCell>Address</TableCell>
            <TableCell>Race</TableCell>
            <TableCell>Eduction</TableCell>
            <TableCell>Employment Status</TableCell>
            <TableCell>Salary</TableCell>
            <TableCell>Company Name</TableCell>
            <TableCell>Designation</TableCell> */}
            <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredStudents
            // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((student, index) => (
              <TableRow key={student.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{student.name.toUpperCase()}</TableCell>
                <TableCell>{student.email}</TableCell>
                <TableCell>{student.phone}</TableCell>
                <TableCell>{student.gender}</TableCell>
                <TableCell>{student.dob}</TableCell>
                {/* <TableCell>{student.address}</TableCell>
              <TableCell>{student.race}</TableCell>
              <TableCell>{student.eduction}</TableCell>
              <TableCell>{student.employmentstatus}</TableCell>
              <TableCell>{student.salary}</TableCell>
              <TableCell>{student.companyname}</TableCell>
              <TableCell>{student.designation}</TableCell> */}
                <TableCell>{student.status}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default StudentTable;
